

import Vue from 'vue'
import Router from 'vue-router'
import Layout from 'layout/index.vue'
Vue.use(Router)

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [{
    path: '/',
    redirect: '/Home',
    component: Layout,
    children: [{
        path: '/Home',
        name: '/Home',
        component: () =>
            import( /* webpackChunkName:"Home" */ '@/views/home/index_tmp.vue'),
        meta: {
            btnPermission: [100, 200, 300, 400, 500, 600, 700, 1, 2]
        }
    },
    {
        path: '/adminUser',
        name: '/adminUser',
        component: () =>
            import( /* webpackChunkName:"adminUser" */ '@/views/system/adminUser/index.vue'),
        meta: {
            btnPermission: [100, 400, 2]
        }
    },
    {
        path: '/investOrder',
        name: '/investOrder',
        component: () =>
            import(/* webpackChunkName: "investOrder" */ '@/views/system/investOrder/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: '/orderFlow',
        name: '/orderFlow',
        component: () =>
            import(/* webpackChunkName: "investOrder" */ '@/views/system/orderFlow/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: '/fundFlow',
        name: '/fundFlow',
        component: () =>
            import(/* webpackChunkName: "investOrder" */ '@/views/system/fundFlow/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: "/periodFlow",
        name: "/periodFlow",
        component: () =>
            import(/* webpackChunkName: "investOrder" */ '@/views/system/periodFlow/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: '/productFlow',
        name: '/productFlow',
        component: () =>
            import(/* webpackChunkName: "investOrder" */ '@/views/system/productFlow/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: '/order',
        name: '/order',
        component: () =>
            import( /* webpackChunkName:"order" */ '@/views/system/order/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: '/overdueOrder',
        name: '/overdueOrder',
        component: () =>
            import( /* webpackChunkName:"order" */ '@/views/system/order/overdueOrder.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: '/finaceOverdueOrder',
        name: '/finaceOverdueOrder',
        component: () =>
            import( /* webpackChunkName:"order" */ '@/views/system/finaceOverdueOrder/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: "/agencyOrder",
        name: "/agencyOrder",
        component: () =>
            import( /* webpackChunkName:"order" */ '@/views/myOrder/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: "/shipping",
        name: "/shipping",
        component: () =>
            import( /* webpackChunkName:"shipping" */ '@/views/system/shippingSetup/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: "/brandManage",
        name: "/brandManage",
        component: () =>
            import( /* webpackChunkName:"shipping" */ '@/views/system/brandManage/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: "/outBond",
        name: "/outBond",
        component: () =>
            import( /* webpackChunkName:"shipping" */ '@/views/system/outBond/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: "/productSeries",
        name: "/productSeries",
        component: () =>
            import( /* webpackChunkName:"shipping" */ '@/views/system/productSeries/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: "/brandDiscount",
        name: "/brandDiscount",
        component: () =>
            import( /* webpackChunkName:"shipping" */ '@/views/system/brandDiscount/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: '/warehouse',
        name: '/warehouse',
        component: () =>
            import( /* webpackChunkName:"warehouse" */ '@/views/system/warehouse/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: "/pricePreset",
        name: "/pricePreset",
        component: () =>
            import( /* webpackChunkName:"warehouse" */ '@/views/system/pricePreset/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: "/productManager",
        name: "/productManager",
        component: () =>
            import( /* webpackChunkName:"warehouse" */ '@/views/system/goods/index.vue'),
        meta: {
            btnPermission: [100, 300, 2]
        }
    },
    {
        path: '/purchase',
        name: '/purchase',
        component: () =>
            import( /* webpackChunkName:"purchase" */ '@/views/purchase/index.vue'),
        meta: {
            btnPermission: [100, 1, 2]
        }
    },
    {
        path: '/diy',
        name: "/diy",
        component: () =>
            import( /* webpackChunkName:"diy" */ '@/views/diy/index.vue'),
        meta: {
            btnPermission: [100, 1, 2]
        }
    },
    {
        path: '/sysUser',
        name: '/sysUser',
        component: () =>
            import( /* webpackChunkName:"sysUser" */ '@/views/system/user/index.vue'),
        meta: {
            btnPermission: [100, 400, 2]
        }
    },
    {
        path: '/myOrder',
        name: '/myOrder',
        component: () =>
            import( /* webpackChunkName:"myOrder" */ '@/views/myOrder/index.vue'),
        meta: {
            btnPermission: [100, 1, 2]
        }
    },
    {
        path: '/blankPage',
        name: '/blankPage',
        component: () =>
            import( /* webpackChunkName:"blank" */ '@/views/userSetup/recharge/Blank.vue'),
        meta: {
            btnPermission: [100, 200, 300, 400, 500, 600, 700, 1, 2]
        }
    },
    {
        path: '/userSetup',
        name: '/userSetup',
        component: () =>
            import( /* webpackChunkName:"userSetup" */ '@/views/userSetup/index.vue'),
        children: [
            {
                path: '/userSetup/recharge',
                name: '/recharge',
                component: () =>
                    import( /* webpackChunkName:"recharge" */ '@/views/userSetup/recharge/index.vue'),
            },
            {
                path: '/userSetup/changeUserInfo',
                name: '/changeUserInfo',
                component: () =>
                    import( /* webpackChunkName:"changeUserInfo" */ '@/views/userSetup/changeUserInfo/index.vue'),
            },
            {
                path: '/userSetup/changePassword',
                name: '/changePassword',
                component: () =>
                    import( /* webpackChunkName:"changePassword" */ '@/views/userSetup/changePassword/index.vue'),
            },
            {
                path: '/userSetup/balance',
                name: '/balance',
                component: () =>
                    import( /* webpackChunkName:"balance" */ '@/views/userSetup/balance/index.vue'),
            },
            {
                path: '/userSetup/myAddress',
                name: '/myAddress',
                component: () =>
                    import( /* webpackChunkName:"address" */ '@/views/userSetup/myAddress/index.vue'),
            },
            {
                path: '/userSetup/myCompany',
                name: '/myCompany',
                component: () =>
                    import( /* webpackChunkName:"myCompany" */ '@/views/userSetup/myCompany/index.vue'),
            },
            {
                path: '/userSetup/qualifications',
                name: 'qualifications',
                component: () =>
                    import( /* webpackChunkName: "qualifications" */ '@/views/userSetup/qualifications/index.vue')
            },
        ],
        meta: {
            btnPermission: [100, 200, 300, 400, 500, 600, 700, 1, 2]
        }
    },
    {
        path: '/fenxiaoExtend/*',
        name: '/fenxiaoExtend',
        component: () =>
            import(
            /* webpackChunkName:"fenxiaoExtend" */ '@/views/system/advance/crm/index.vue'
            ),
        meta: {
            btnPermission: [100, 300, 500, 2],
        },
    },
    {
        path: '/fenxiaoExtendAdvance/*',
        name: '/fenxiaoExtendAdvance',
        component: () =>
            import(
            /* webpackChunkName:"fenxiaoExtendAdvance" */ '@/views/system/advance/crm/index.vue'
            ),
        meta: {
            btnPermission: [100, 300, 500, 2],
        },
    },
    {
        path: '/finaceAduit/inovice/*',
        name: '/finaceAduit/inovice',
        component: () =>
          import(
            /* webpackChunkName:"orderRate" */ '@/views/system/advance/crm/index.vue'
          ),
        meta: {
          btnPermission: [100, 300, 500, 2],
        },
      },
    ]
},
{
    path: '/login',
    component: () =>
        import('@/views/login/index.vue'),
    hidden: true,
    meta: {
        btnPermission: [100, 200, 300, 400, 500, 600, 700, 1, 2]
    }
},
{
    path: '/404',
    component: () =>
        import('@/views/404.vue'),
    hidden: true,
    meta: {
        btnPermission: [100, 200, 300, 400, 500, 600, 700, 1, 2]
    }
}
]

/* added by wangchao 重写VueRouter的push方法*/
const orginalPush = Router.prototype.push
Router.prototype.push = function (location) {
    // @ts-ignore
    return orginalPush.call(this, location).catch((err) => { err })
}

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = []

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes: constantRoutes
})

const router = createRouter()
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    // @ts-ignore
    router.matcher = newRouter.matcher // reset router
}

export default router